import { QUERY_GET_ACTIONRESOLUTIONS } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getActionResolutions = baseThunk(`actionResolutions/getActionResolutions`, QUERY_GET_ACTIONRESOLUTIONS, "GET")
